import request from '@/utils/request'

/** 按场景发送短信（生日祝福等） */
export function sendSmsByScene(data) {
  return request({
    url: '/api/Extend/LqSms/SendByScene',
    method: 'post',
    data
  })
}

/** 生日短信批量发送（可选） */
export function sendBirthdaySms(data) {
  return request({
    url: '/api/Extend/LqSms/SendBirthday',
    method: 'post',
    data
  })
}
